module.exports = __webpack_public_path__ + "img/payfail.44ff6ddb.svg";